module.exports = __webpack_public_path__ + "static/media/link-icon-black.8bafe6c6.svg";